// @flow

import anime from "animejs";

const scrollToEl = (
    element: HTMLElement,
    duration: number = 500,
    offset?: number = 0
) => {
    const elementOffset = element.getBoundingClientRect().top;
    const scrollPosition = window.scrollY || window.pageYOffset;
    const scrollOffset = elementOffset + scrollPosition;
    // console.log("scroll", elementOffset, scrollPosition, scrollOffset);
    anime({
        targets: [document.documentElement, document.body],
        scrollTop: scrollOffset + offset,
        duration: duration,
        easing: "easeInOutQuad",
    });
};

export default scrollToEl;
